import React, { useState } from "react";
import "../../scss/index.scss";
import useWindowSize from "../../utils/useWindowSize";

const WithdrawStatusPill = ({ status }) => {
  if (status === "done") {
    return (
      <span className="pill done">
        <span className="pd" />
        {status}
      </span>
    );
  }
  if (status === "withdraw failed" || status === "Deposit Not Completed") {
    return (
      <span className="pill fail">
        <span className="pd" />
        {status}
      </span>
    );
  }
  return (
    <span className="pill pend">
      <span className="pd" />
      {status}
    </span>
  );
};

const TableDataWithdraws = ({ item, currentDiv, tableOpen }) => {
  const sized = useWindowSize();

  const [openDiv, setOpenDiv] = useState(false);

  const openTable = () => {
    if (tableOpen === "") {
      setOpenDiv(true);
      currentDiv(item.id, openDiv);
    } else if (tableOpen === item.id) {
      setOpenDiv(!openDiv);
    } else if (tableOpen !== "" && tableOpen !== item.id) {
      setOpenDiv(true);
      currentDiv(item.id);
    }
  };

  if (sized.width > 900) {
    return (
      <div
        className="gtRow"
        style={{
          gridTemplateColumns:
            "90px 150px minmax(220px,1.4fr) 170px 130px 130px 150px",
        }}
      >
        <div className="cellMono">#{item.id}</div>
        <div className="cellStrong">
          {Number(item.withdrawAmount).toFixed(2)} USDC
        </div>
        <div className="cellMono">{item.withdrawWallet}</div>
        <div className="cellDate" style={{ color: "#7c847e" }}>
          {item.dateTime}
        </div>
        <div>
          <WithdrawStatusPill status={item.status} />
        </div>
        <div className="cellFee">
          {Number(item.withdrawAmountInUsd).toFixed(2)} USDC
        </div>
        <div className="r">
          {item.txnHash ? (
            <a
              href={item.txnHashExplorerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="txBtn"
            >
              Etherscan ↗
            </a>
          ) : (
            <span className="cellMono">—</span>
          )}
        </div>
      </div>
    );
  }

  const expanded = openDiv && tableOpen === item.id;

  return (
    <div className="mCard">
      <div className="mTop" onClick={openTable}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
          <span className="cellMono">#{item.id}</span>
          <span className="cellStrong">
            {Number(item.withdrawAmount).toFixed(2)} USDC
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, flex: "none" }}>
          <WithdrawStatusPill status={item.status} />
          <span style={{ color: "#5d645f", fontSize: 12 }}>{expanded ? "▴" : "▾"}</span>
        </div>
      </div>

      {expanded && (
        <div className="mBody">
          <div className="mKV">
            <span className="k">Withdraw Wallet</span>
            <span className="v">{item.withdrawWallet}</span>
          </div>
          <div className="mKV">
            <span className="k">Date</span>
            <span className="v">{item.dateTime}</span>
          </div>
          <div className="mKV">
            <span className="k">Profits</span>
            <span className="v">
              {Number(item.withdrawAmountInUsd).toFixed(2)} USDC
            </span>
          </div>
          {item.txnHash && (
            <div className="mKV">
              <span className="k">Transaction</span>
              <span className="v">
                <a
                  href={item.txnHashExplorerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="txBtn"
                >
                  Etherscan ↗
                </a>
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TableDataWithdraws;
